import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSession } from '../../state/session'
import useRoutes from '../../state/useRoutes'
import Button from '../basics/Button/Button'
import ExpandedIndicator from '../basics/ExpandedIndicator/ExpandedIndicator'
import Menu from '../basics/Menu/Menu'

import styles from './AssumeClientMenu.module.scss'

export default React.memo(function AssumeClientMenu() {
  const { t } = useTranslation()
  const { user: currentUser, assumeClient } = useSession()
  const routes = useRoutes()

  const currentClientName = currentUser?.assumableClients?.find(({ uuid }) => uuid === currentUser?.clientUuid)?.name

  const handleAssumeClient = useCallback<React.MouseEventHandler<HTMLButtonElement>>(
    (e) => {
      const clientUuid = e.currentTarget.dataset.clientUuid
      if (!clientUuid) {
        return
      }
      routes.dashboard.goto({})
      assumeClient(clientUuid)
    },
    [assumeClient, routes]
  )

  if (!currentUser?.assumableClients || currentUser.assumableClients.length < 2) {
    return null
  }

  return (
    <Menu
      small
      label={
        <>
          <span>{currentClientName || t('unknown client')}</span>
          <ExpandedIndicator />
        </>
      }
      className={styles.AssumeClientMenu}
    >
      {currentUser?.assumableClients?.map(({ uuid, name }) => (
        <li key={uuid}>
          <Button menuItem data-client-uuid={uuid} onClick={handleAssumeClient}>
            {name}
          </Button>
        </li>
      ))}
    </Menu>
  )
})
